<template>
  <div class="elsa-table-layout">
    <div class="elsa-table-layout-title" v-if="showTitle">
      <h1 class="title-header">
        {{ title }}
      </h1>
    </div>
    <div class="elsa-table-layout-header flex">
      <div class="header-start flex items-center" v-if="selectedDataSourceCount > 0">
        <div class="more-action-text mr-px-8">
          <label class="mr-px-8">{{
            $t('common.data_selelected_info', {
              selected: selectedDataSourceCount,
              total: dataSourceCount
            })
          }}</label
          ><el-button type="text" @click="selectAll(dataSource)">{{ selectText }}</el-button>
        </div>
        <div v-if="selectedDataSourceCount">
          <slot name="alert-actions"> </slot>
        </div>
      </div>
      <div class="header-end ml-auto flex">
        <div class="mr-px-16" v-if="sortable">
          <sort-by-option
            v-on:sort-func="sortFuncBase"
            :ordering.sync="_ordering"

          />
        </div>
        <div class="mr-px-16" v-if="searchable">
          <el-form class="search-form">
            <elsa-search v-model="_queryString" @search="search" />
          </el-form>
        </div>
        <slot name="toolBar">
          <div class="create-new-study-set" v-if="createUrl">
            <router-link :to="createUrl" tag="button">
              {{ $t('common.new') }}
            </router-link>
          </div>
        </slot>
      </div>
    </div>
    <div class="table-wrapper">
      <el-table v-bind="$attrs" ref="multipleTable" :data="dataSource" :empty-text="$t('common.no_values')" @select-all="handleSelectRow" @select="handleSelectRow" @cell-mouse-enter="handleCellMouseEnter" @cell-mouse-leave="handleCellMouseLeave" @sort-change="handleSortChange" style="width: 100%" :default-sort="{ prop: 'updated_at', order: 'descending' }">
        <el-table-column type="selection" v-if="selection" width="40" align="center"> </el-table-column>
        <slot name="cols"></slot>
      </el-table>
    </div>
    <div class="elsa-table-layout-footer">
      <pagination :page-size="pageSize" :total="total" :current-page.sync="_currentPage" v-on:current-change="currentChange" :pager-counter="pageCounter" />
      <over-table-pagination v-show="isShowPaginationText" :currentPage="_currentPage" :pageSize="pageSize" :total="total" :formatter="overtablePaginationFormatter" />
    </div>
  </div>
</template>

<script>
import OverTablePagination from '@/components/common/v2/OverTablePagination'
import Pagination from '@/components/common/Pagination'
import ElsaSearch from '@/components/common/v2/Search'
import SortByOption from '@/components/common/SortByOption'
import { PAGE_COUNTER, NUMBER_ELEMENTS_PER_PAGE } from '@/constants/generic'
import { STUDENT } from '@/constants/userRoles'
import { mapGetters, mapActions } from 'vuex'
import { always, pathOr } from 'ramda'

export default {
  components: {
    OverTablePagination,
    Pagination,
    ElsaSearch,
    SortByOption
  },
  props: {
    searchable: {
      type: Boolean,
      default: false
    },
    currentPage: {
      type: Number,
      default: 1
    },
    total: {
      type: Number
    },
    pageCounter: {
      type: Number,
      default: PAGE_COUNTER
    },
    pageSize: {
      type: Number,
      default: NUMBER_ELEMENTS_PER_PAGE
    },
    currentChange: {
      type: Function,
      default: () => {}
    },
    queryString: {
      type: String,
      default: null
    },
    ordering: {
      type: String,
      default: '-start_date'
    },
    queryPlaceholder: {
      type: String
    },
    title: {
      type: String
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    search: {},
    screen: {
      type: String,
      default: STUDENT
    },
    dataSource: {
      type: Array,
      default: () => []
    },
    selectedDataSource: {
      type: Array,
      default: () => []
    },
    request: {
      type: Function,
      // eslint-disable-next-line no-unused-vars
      default: (_params) => {}
    },
    createUrl: {
      type: String
    },
    isShowPaginationText: {
      type: Boolean,
      default: true
    },
    sortable: {
      type: Boolean,
      default: false
    },
    sortFuncSpec: {
      type: Function,
      default: () => {}
    },
    selection: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showPendingUsersModal: false,
      sortby_visible: false
    }
  },
  computed: {
    _currentPage: {
      get() {
        return this.currentPage
      },
      set(page) {
        this.$emit('update:current-page', page)
      }
    },
    _queryString: {
      get() {
        return this.queryString
      },
      set(queryString) {
        this.$emit('update:query-string', queryString)
      }
    },
    _ordering: {
      get() {
        return this.ordering
      },
      set(ordering) {
        this.$emit('update:ordering', ordering)
      }
    },
    _selectedDataSource: {
      get() {
        return this.selectedDataSource
      },
      set(selectedDataSource) {
        this.$emit('update:selected-data-source', selectedDataSource)
      }
    },
    dataSourceCount() {
      return this.dataSource ? this.dataSource.length : 0
    },
    selectedDataSourceCount() {
      return this._selectedDataSource ? this._selectedDataSource.length : 0
    },
    isSelectedAll() {
      return this.dataSourceCount > 0 && this.dataSourceCount == this.selectedDataSourceCount
    },
    selectText() {
      if (this._selectedDataSource.length == this.dataSourceCount) {
        return this.$t('common.deselect_all')
      } else {
        return this.$t('common.select_all')
      }
    }
  },
  mounted() {
    this.reset()
  },
  methods: {
    handleSelectRow(rowData) {
      this._selectedDataSource = rowData
    },
    selectAll(rows) {
      if (rows) {
        if (this._selectedDataSource.length < this.dataSourceCount) {
          this.$refs.multipleTable.clearSelection()
          rows.forEach((row) => {
            this.$refs.multipleTable.toggleRowSelection(row)
          })
          this._selectedDataSource = rows
        } else {
          this._selectedDataSource = []
          this.$refs.multipleTable.clearSelection()
        }
      }
    },
    reloadAndRest() {
      this._currentPage = 1
      this.request({ page: this._currentPage, search: this._queryString })
    },
    reload() {
      this.request({ page: this._currentPage, search: this._queryString })
    },
    reset() {
      this._currentPage = 1
      this._queryString = ''
      this.request({ page: this._currentPage, search: this._queryString })
    },
    overtablePaginationFormatter(start, end, total) {
      return this.$t('information.show_from_to_of_total', {
        start: start,
        end: end,
        total: total
      })
    },
    handleCellMouseEnter(row, column, cell, event) {
      this.$emit('cell-mouse-enter', row, column, cell, event)
    },
    handleCellMouseLeave(row, column, cell, event) {
      this.$emit('cell-mouse-leave', row, column, cell, event)
    },
    handleSortChange({column, prop, order}) {
      this.$emit('sort-change',{column, prop, order})

    },
    sortFuncBase() {
      this.sortFuncSpec();
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/colors';

::v-deep .search-box.elsa-input {
  margin-top: 16px;

  .el-input .el-input__inner {
    padding-left: 15px;
  }
}

.more-action-text,
.more-action-text a {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
}

::v-deep .search-form {
  min-width: 326px;
  input.el-input__inner {
    background: none !important;
  }
}

.actions {
  margin-top: 0px;
  margin-bottom: 0px;
  display: flex;
  justify-content: flex-start;

  &::v-deep .el-collapse {
    border: none;

    .el-collapse-item__header {
      min-width: 185px;
      // width: 160px;
      height: 40px;
      background: $purple;
      border: 2px solid $purple;
      border-radius: 45px;
      font-weight: 600;
      font-size: 14px;
      color: white;
      text-align: center;
      .button {
        width: 100%;
        i {
          font-size: 18px;
          vertical-align: text-top;
          margin-right: 2px;
        }
      }
    }

    .el-collapse-item__wrap {
      position: absolute;
      z-index: 2;
      margin-top: 8px;
      box-shadow: 0px 4px 7px rgba(4, 33, 50, 0.1);
      padding: 12px 16px;
      min-width: 220px;
    }
    .el-collapse-item__content {
      padding-bottom: 0;
    }
  }
}

.options {
  display: flex;
  flex-direction: row;
  align-items: center;
  display: flex;
  justify-items: flex-start;
  height: 40px;
}

.actions .options ::v-deep .el-collapse .el-collapse-item__header {
  background: linear-gradient(180deg, #29f4ff -46.11%, #5257ff 151.97%);
  box-shadow: 0px 8px 18px rgba(69, 137, 255, 0.26);
  border-radius: 50px;
  font-weight: bold;
  font-size: 14px;
  color: white;
  padding-right: 10px;

  &.is-active {
    color: white;
    background-color: $purple;
  }
}

::v-deep .action-item {
  display: flex;
  flex-direction: row;
  margin-top: auto;
  margin-bottom: auto;
  color: $purple;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  line-height: 22px;

  &:not(:last-of-type) {
    margin-bottom: 16px;
  }

  &:hover {
    font-size: 14px;
    font-weight: 800;
  }

  i {
    border-width: 2px;
    height: 16px;
    width: 16px;
    padding-right: 8px;
    font-size: 16px;
    margin: auto 0;
  }
}

::v-deep .el-table tr {
  cursor: pointer;
}
.elsa-table-layout {
  padding: 40px;
}
.elsa-table-layout-header {
  padding-bottom: 12px;
  padding-top: 10px;
}

.elsa-table-layout-footer {
  padding-top: 48px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  position: relative;
  height: 32px;
  align-items: center;
  .el-pagination {
    position: absolute;
    /* width: 100%; */
    margin: auto;
    margin-left: auto;
    left: 50%;
    transform: translateX(-50%);
    margin-right: auto;
  }
}

.elsa-table-layout-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  & > div {
    align-self: center;
  }
}

.el-form {
  &.search-form {
    margin-top: 0px;
    padding-bottom: 0px;
  }
}
::v-deep .elsa-input .el-input .el-input__inner {
  height: 44px;
}
button.invite-single-learner {
  background: #007eff;
  border-radius: 8px;
  border: none;
  height: 48px;
  color: white;
  padding: 16px;
  font-size: 18px;
  min-width: 215px;
  cursor: pointer;
  // font-weight: bold;
  margin: 0 10px;
  &:hover {
    background: #0362c4;
  }
}
.pending-learner {
  height: 48px;
}
.elsa-table-layout-title {
  .title-header {
    margin: 8px 0 32px 0px;
  }
}

.elsa-table-layout-footer {
  padding-top: 24px !important;
 
}

.over-table-pagination {
  width: auto !important;
}
</style>
